import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ChildcaresDataTable {
  constructor() {
    $(document).ready(function() {
      showChildcareCoursesTable();
    });

    $(document).on("turbo:load", function() {
      showChildcareCoursesTable();
    });

    function showChildcareCoursesTable() {
      $('#childcare-courses-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#childcare-courses-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "start_date"},
          {"data": "end_date"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
